export default __webpack_public_path__ + "static/100--stacked-area-841a1a6eb2369d70a01c456cb16c5a15.png";